import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Inject } from '@angular/core';
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { searchElementUpwards } from 'src/app/utils/dom.utils';

@Directive({
  selector: '[markRequired]',
})
export class MarkRequiredDirective implements AfterViewInit {
  @Input('markRequired') form: FormGroup;

  constructor(private elRef: ElementRef<HTMLElement>, private renderer: Renderer2, @Inject(DOCUMENT) private document) {}

  ngAfterViewInit() {
    this.markRequiredFields();
  }

  private markRequiredFields(): void {
    Object.entries(this.form.controls).forEach(([name, control]) => {
      const validators = control.validator?.({} as AbstractControl);

      if (validators?.required) {
        this.addAsterisk(name);
      }
    });
  }

  private addAsterisk(controlName: string): void {
    const controlElement = this.elRef.nativeElement.querySelector<HTMLElement>(`[formControlName="${controlName}"]`);
    if (!controlElement) { return; }
    const label = searchElementUpwards(controlElement, 'label');

    if (label) {
      const asterisk = this.document.createElement('span');
      asterisk.innerHTML = ' <sup><i class="mdi mdi-asterisk tiny danger"></i></sup>';
      this.renderer.appendChild(label, asterisk);
    }
  }
}
